import { Avatar as NextAvatar } from '@nextui-org/react';
import styled from 'styled-components';

interface AvatarProps {
  borderRadius?: string;
  border?: string;
  fontSize?: string;
  fontColor?: string;
  backgroundColor?: string;
  width?: number;
  height?: number;
}

const defaultBorderRadius = 0;

const Avatar = styled(NextAvatar)<AvatarProps>`
  width: ${({ width }) => (width ? `${width}rem` : 'auto')};
  height: ${({ height }) => (height ? `${height}rem` : 'auto')};
  border-radius: ${({ borderRadius }) => borderRadius || defaultBorderRadius};
  .nextui-avatar-bg,
  .nextui-avatar-img {
    background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.primary.c500};
    border-radius: ${({ borderRadius }) => borderRadius || defaultBorderRadius};
    border: ${({ border }) => border || 'none'};
  }
  .nextui-avatar-text {
    color: ${({ fontColor, theme }) => fontColor || theme.colors.neutrals.black};
    font-size: ${({ fontSize, theme }) => fontSize || theme.fontSize.l};
  }
`;

export default Avatar;
